<section class="build-section ws-product-detail__section"
         [class.active]="active"
         [class.disabled]="disabled">

  <div [hidden]="!title"
       class="build-section__header ws-product-detail__section-title mb-1">
    {{title}}
  </div>

  <div class="help-text-wrap ws-product-detail__section-help">
    <ng-content select=".help-text"></ng-content>
  </div>

  <div class="build-section__content wysiwyg {{ contentExtraClass }}"
       [class.mt-4]="!contentOnly">
    <ng-content></ng-content>
  </div>

  @if (disabled) {
    <div class="blocker-layer ws-product-detail__blocker"></div>
  }
</section>
